import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDataSourceDocument } from './update.generated';

export const useUpdateDataSource = (options: ApiOptions<typeof UpdateDataSourceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateDataSourceDocument, {
    ...useNotifications(UpdateDataSourceDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_sources.update_success'),
    }),
    ...options,
  });
};
